<script setup lang="ts">
import { computed } from "vue";

import type { Decision, DecisionAnswer, DecisionOption, Operation } from "@/models/RecordMigration";

withDefaults(defineProps<{ operations: Operation[] }>(), {  })

const answers = defineModel<DecisionAnswer[]>({ required: true });

const decisions = computed(() => {
  const byId = new Map<string, Decision>();
  for (const operation of __props.operations) {
    for (const decision of operation.requiredDecisions) {
      if (!byId.has(decision.id)) byId.set(decision.id, decision);
    }
  }
  return [...byId.values()];
});

function answerFor(decisionId: string): DecisionOption | undefined {
  return answers.value.find((answer) => answer.decisionId === decisionId)?.option;
}

function setAnswer(decisionId: string, option: DecisionOption) {
  answers.value = [...answers.value.filter((answer) => answer.decisionId !== decisionId), { decisionId, option }];
}
</script>
<template>
  <div class="tw-flex tw-flex-col tw-gap-3">
    <p role="alert" class="tw-flex tw-items-center tw-gap-2 tw-text-sm">
      <i class="fas fa-circle-exclamation tw-mt-0.5 tw-shrink-0" aria-hidden="true" />
      Some of the selected files require additional decisions before this plan can be migrated.
    </p>
    <fieldset v-for="decision in decisions" :key="decision.id" class="tw-flex tw-flex-col tw-gap-1.5">
      <legend class="tw-mb-1 tw-text-sm tw-font-medium">{{ decision.prompt }}</legend>
      <div
        v-for="allowedOption in decision.allowedOptions"
        :key="allowedOption.value"
        class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm"
      >
        <input
          :id="`migration-decision-${decision.id}-${allowedOption.value}`"
          type="radio"
          :name="`migration-decision-${decision.id}`"
          :required="decision.isRequired"
          :checked="answerFor(decision.id) === allowedOption.value"
          @change="setAnswer(decision.id, allowedOption.value)"
        />
        <label :for="`migration-decision-${decision.id}-${allowedOption.value}`">{{ allowedOption.label }}</label>
      </div>
    </fieldset>
  </div>
</template>
